<template>
    <div
        class="slide-cards-wrapper"
        :class="{
            'show-partial-page-slides': isShowFilter,
            'adjust-margin': slideType
        }"
    >
        <div v-if="showCards">
            <slide-cards-container
                v-for="(container, index) in slideContainers"
                :id="`instrument-${container.esId}`"
                :key="index"
                :container="container"
            />
        </div>
        <div v-else class="no-slides">
            {{ $translate('no_slides_found') }}
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import SlideCardsContainer from '../SlideCardsContainer'
import { SLIDE_TIME_ATTRIBUTION } from '../../../business/const'

export default {
    name: 'SlideCardsWrapper',
    components: { SlideCardsContainer },
    props: {
        slideContainers: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            SLIDE_TIME_ATTRIBUTION,
            scrollEl: null
        }
    },
    computed: {
        ...mapState({
            homePageSelectedView: state => state.timelapse.homePageSelectedView,
            isPastSlideLoading: state => state.timelapse.isPastSlideLoading,
            isShowFilter: state => state.filter.isShowFilter
        }),
        slideType() {
            return this.homePageSelectedView === SLIDE_TIME_ATTRIBUTION.FINISHED
        },
        showCards() {
            return (
                this.slideContainers.filter(instrument => instrument.filteredSlides.length > 0)
                    .length > 0
            )
        }
    },
    watch: {
        $route: {
            immediate: true,
            handler(to) {
                const { query } = to

                if (query.instrument) {
                    this.scrollToInstrument(query.instrument)
                }
            }
        }
    },
    mounted() {
        this.scrollEl = document.querySelector('.slide-cards-wrapper')
        if (this.scrollEl) {
            this.scrollEl.addEventListener('scroll', this.handleScroll)
        }
    },
    beforeDestroy() {
        if (this.scrollEl) {
            this.scrollEl.removeEventListener('scroll', this.handleScroll)
            this.scrollEl = null
        }
    },
    methods: {
        scrollToInstrument(esId) {
            this.$nextTick(() => {
                const target = document.getElementById(`instrument-${esId}`)
                target.parentNode.scrollTop = target.offsetTop
            })
        },
        handleScroll(event) {
            if (this.homePageSelectedView !== SLIDE_TIME_ATTRIBUTION.FINISHED) return

            const { scrollTop, scrollHeight, clientHeight } = event.target
            const lastChild = document.querySelector(
                '.card.slide-card.rounded-sm.slide-exist:last-child'
            )
            const isAtBottom =
                scrollTop + clientHeight >=
                scrollHeight - (lastChild ? lastChild.clientHeight * 2 : 1)

            if (isAtBottom && !this.isPastSlideLoading) {
                this.$store.dispatch('timelapse/loadMoreSlides')
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.slide-cards-wrapper {
    position: relative;
    height: 100%;
    padding: 0 0.1rem 3rem 1rem;
    overflow: auto;
    display: flex;
    flex-direction: column;
    @include hide-scrollbar();
    transition: 0.5s;
    width: 100%;

    &.show-partial-page-slides {
        transition: 0.5s;
        width: 78%;
    }
    &.adjust-margin {
        margin-top: 1.5rem;
    }
}
</style>

<style lang="scss">
.slide-cards-wrapper {
    .slide-cards-container {
        max-width: 1344px;
        margin: 0 auto;
    }
}
.no-slides {
    position: relative;
    margin: 3rem 2rem;
    padding: 5px 40px 5px 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background-color: $red-alpha;
    border: 0.1rem solid $red;
    color: $red;
    min-height: 2rem;
    font-size: 14px;
}
</style>
